import { ChangeEvent, useState } from "react";

import { VolumeMax, VolumeMin, VolumeOff } from "@/icons";
import { cn } from "@/utils";

export const VolumeSlider = ({
  className,
  volume,
  handleVolumeChange,
  muted,
  toggleMute,
}: {
  className?: string;
  volume: number;
  handleVolumeChange: (e: ChangeEvent<HTMLInputElement>) => void;
  muted: boolean;
  toggleMute: () => void;
}) => {
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);

  const getVolumeIcon = () => {
    if (muted || volume === 0) {
      return <VolumeOff />;
    } else if (volume > 0.8) {
      return <VolumeMax />;
    } else {
      return <VolumeMin />;
    }
  };

  return (
    <div
      className={cn("flex items-center", className)}
      onMouseEnter={() => setShowVolumeSlider(true)}
      onMouseLeave={() => setShowVolumeSlider(false)}
    >
      <button
        className="h-6 w-6 focus-visible:outline-none"
        onClick={toggleMute}
      >
        {getVolumeIcon()}
      </button>
      {showVolumeSlider && (
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={handleVolumeChange}
          className="ml-2 h-1 w-24 cursor-pointer appearance-none rounded-lg bg-[#CACACA80] accent-white focus-visible:outline-none"
          style={{
            top: "-1.5rem",
            right: "0.5rem",
            background: `linear-gradient(to right, white ${volume * 100}%, rgba(202, 202, 202, 0.5) ${volume * 100}%)`,
          }}
        />
      )}
    </div>
  );
};
